import React from 'react';
import PropTypes from 'prop-types';

const VariableCostsHOC = (C) => {
  const VariableCostsComp = ({services}) => (services && services.length ? <C services={services} /> : null);

  VariableCostsComp.PropTypes = {
    services:PropTypes.array.isRequired,
  };

  return VariableCostsComp;
};

export default VariableCostsHOC;
